export default{
    methods: {
        goToErrorInput: function(){
            var vm = this
            $.each(vm.$validator.errors.items, function (index, error) {
                if (vm.$el.querySelector('[data-vv-name="' + error.field + '"]')) {
                    vm.$nextTick(function(){
                        vm.$el.querySelector('[data-vv-name="' + error.field + '"]').scrollIntoView()
                    })
                    return false
                } else if (vm.$el.querySelector('[name="' + error.field + '"]')) {
                    vm.$nextTick(function () {
                        vm.$el.querySelector('[name="' + error.field + '"]').scrollIntoView()
                    })
                    return false
                }
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/errorMixin.js